import { render } from "./DraftClinicalCase.vue?vue&type=template&id=8f619cba&scoped=true"
import script from "./DraftClinicalCase.vue?vue&type=script&lang=js"
export * from "./DraftClinicalCase.vue?vue&type=script&lang=js"

import "./DraftClinicalCase.vue?vue&type=style&index=0&id=8f619cba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f619cba"]])

export default __exports__